export default (function (siteVars) {
  return {
    dividerColor: siteVars.colors.white,
    textColor: siteVars.colors.white
  };
});